<template>
    <div>
        <pt-page-title title="编辑报名记录"></pt-page-title>
        <pt-sign-notes-form-width-data :isEdit="isEdit" :id="id" :noteId="noteId" @submiting="submiting"
        ref="formData"></pt-sign-notes-form-width-data>
        <div class="button-div">
            <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
            <el-button type="primary" @click="cancel" plain>取消</el-button>
        </div>
    </div>
</template>
<script>
import ptSignNotesFormWidthData from './withData'
export default {
  components: {
    ptSignNotesFormWidthData
  },
  props: {
    isEdit: {
      type: Boolean
    },
    id: {
      type: String
    },
    noteId: {
      type: String
    }
  },
  data () {
    return {
      submitLoading: false
    }
  },
  methods: {
    submiting (val) {
      this.submitLoading = val
    },
    submit () {
      this.$refs.formData.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style lang="less">

</style>
